import { render, staticRenderFns } from "./SectionSideNav.vue?vue&type=template&id=431bd694&"
import script from "./SectionSideNav.vue?vue&type=script&lang=js&"
export * from "./SectionSideNav.vue?vue&type=script&lang=js&"
import style0 from "./SectionSideNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports